__turbopack_context__.v({
  "checkbox": "checkbox-component-module-scss-module__tJ_aIa__checkbox",
  "checkbox--disabled": "checkbox-component-module-scss-module__tJ_aIa__checkbox--disabled",
  "checkbox-input": "checkbox-component-module-scss-module__tJ_aIa__checkbox-input",
  "checkbox-input--disabled": "checkbox-component-module-scss-module__tJ_aIa__checkbox-input--disabled",
  "checkbox-input--modified": "checkbox-component-module-scss-module__tJ_aIa__checkbox-input--modified",
  "checkbox-label": "checkbox-component-module-scss-module__tJ_aIa__checkbox-label",
});
